import type { Options } from '../types';
import entries from 'lodash/entries';

/**
 * The parameterize utility will take a set of key value pairs (number, string,
 * and booleans) and produce a parameter string of the same keys and values, joined
 * with the equals sign `=`, combined with an ampersand `&` to other key value
 * pairs. It can be paired up with a question mark `?` to make a query string.
 *
 * @param {Object} options - The options object
 * @param {number|string|boolean} options.key - Can be any named parameter of
 *     the given types
 * @return {string} The parameter string
 *
 * @example
 * parameterize({greeting: 'hello', repeat: 10, to_world: true})
 * // greeting=hello&repeat=10&to_world=true
 */
export const parameterize = (options: Options): string => {
  return entries(options)
    .map(([k, v]) => {
      if (typeof v === 'object' && Array.isArray(v)) {
        let arrayRep = v.reduce((mem, el) => {
          mem.push(`${k}[]=${encodeURIComponent(String(el))}`);
          return mem;
        }, []);
        return arrayRep.join('&');
      }
      return `${k}=${encodeURIComponent(String(v))}`;
    })
    .join('&');
};

export default parameterize;
